export default {
    /**
     * 时间戳转日期 秒
     * @param originVal 时间戳
     * @return 日期 yyyy-mm-dd HH:MM:SS
     */
    dateFormat(originVal) {
        // const dt = new Date(originVal*1000) 毫秒时间戳 可自行判断
        const dt = new Date(originVal)
        const y = dt.getFullYear()
        const m = (dt.getMonth() + 1 + '').padStart(2, '0')
        const d = (dt.getDate() + '').padStart(2, '0')

        const hh = (dt.getHours() + '').padStart(2, '0')
        const mm = (dt.getMinutes() + '').padStart(2, '0')
        const ss = (dt.getSeconds() + '').padStart(2, '0')

        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
    },

    /**
     * 获取指定天数前日期
     * @param date
     * @return 日期 yyy-mm-dd
     */
    getBeforeNumToDate(num){
        let n = num;
        let d = new Date();
        let year = d.getFullYear();
        let mon = d.getMonth() + 1;
        let day = d.getDate();
        if(day <= n) {
            if(mon > 1) {
                mon = mon - 1;
            } else {
                year = year - 1;
                mon = 12;
            }
        }
        d.setDate(d.getDate() - n);
        year = d.getFullYear();
        mon = d.getMonth() + 1;
        day = d.getDate();
        let s = year + "-" + (mon < 10 ? ('0' + mon) : mon) + "-" + (day < 10 ? ('0' + day) : day);
        return s;
    },
    /**
     * 日期转指定格式字符串
     * @param date 日期
     * @param format 日期格式
     * @return 字符串
     */
    getFormatDate(date,format) {
        let time={
            'M+':date.getMonth() + 1,
            'd+':date.getDate()
        }

        if(/(y+)/i.test(format)){
            format= format.replace(RegExp.$1,(date.getFullYear()+ '').substr(4 - RegExp.$1.length))
        }
        for(let k in date){
            if(new RegExp('('+ k +')').test(format)) {
                format = format.replace(RegExp.$1,RegExp.$1.length ===1 ? date[k] : ('00' + date[k]).substr(('' + date[k]).length))
            }
        }
        return format
    },

}
